export default function TermsOfUse() {
  return (
    <main className="mt-12 md:mt-0" style={{ background: "#fafafa", minHeight: "100vh", fontFamily: "'Georgia', serif" }}>

      {/* HERO */}
    {/* HERO */}
<div style={{
  background: "linear-gradient(to bottom, #6A1B9A, #9C27B0)",
  padding: "25px 15px 25px",
  textAlign: "center",
}}>
       
        <h1 style={{ color: "#fff", fontSize: "clamp(28px, 5vw, 48px)", fontWeight: "700", margin: "0 0 14px" }}>
          Terms of Use
        </h1>
        <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", fontFamily: "sans-serif" }}>
          Last updated: 27 May 2026
        </p>
      </div>

      {/* CONTENT */}
      <div style={{ maxWidth: "820px", margin: "0 auto", padding: "24px 24px 20px" }}>

        <Section title="Overview">
          <P>The following terms and conditions govern your use of <strong>confidays.com</strong> (hereinafter referred to as "Site") owned by <strong>Maheshwari Industries</strong> (hereinafter referred to as "we", "us" or "our").</P>
          <P>By using the Site, you accept and agree to the terms and conditions under these Terms of Use.</P>
        </Section>

        <Section title="Terms of Sale">
          <P>This Site offers for sale sanitary pads, Cramp Comfort heat patches (hereinafter referred to as "Products"). By accessing the Site or purchasing the Products you agree to terms and conditions set forth herein.</P>
          <P>We reserve the right to refuse service to anyone for any reason at any time.</P>
          <P>Prices of our products/services/subscriptions are subject to change without notice. We reserve the right to modify or discontinue any product/service/subscription without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance.</P>
          <P>We also reserve the right, with or without notice, to reduce the quantity of any product/service/subscription to be provided to you, at our sole discretion.</P>
        </Section>

        <Section title="Warnings for Confidays Sanitary Pads">
          <OL items={[
            "Change your pad every 6–8 hours, even on low flow and spotting days.",
            "If you require XXXL pads to manage extremely heavy flow or post-pregnancy flow, Confidays sanitary pads may not be best suited for your flow.",
            "If you experience any discomfort or irritation while using a pad, kindly discontinue usage. If irritation persists, consult a doctor.",
          ]} />
        </Section>

        <Section title="Warnings for Cramp Comfort">
          <SubTitle>Usage</SubTitle>
          <OL items={[
            "Check your skin frequently during use. If you find signs of discomfort, irritation, redness, burns or find the patch too hot, remove immediately.",
            "Do not use more than one patch in a 24-hour period.",
            "Do not use a patch for more than 8 hours.",
            "Do not stick the patch directly on skin.",
            "Do not use while sleeping.",
            "Do not use on the face, open wounds, damaged skin or with other forms of heat.",
            "Do not use the patch with any balm or essential oils.",
            "Do not apply strong pressure on the patch or use with tight clothes, belts or waistbands.",
            "Do not use if the patch is leaking, torn or damaged.",
            "Do not use on delicate fabrics, as the sticky strip may cause damage upon removal.",
          ]} />
          <SubTitle>Medical</SubTitle>
          <OL items={[
            "In case of diabetes, pregnancy, desensitized skin or heart disease, consult your doctor before use.",
            "In case of ingestion or any discomfort, consult a doctor immediately.",
          ]} />
        </Section>

      </div>
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "40px", borderBottom: "1px solid #f0f0f0", paddingBottom: "36px" }}>
      <h2 style={{
        fontSize: "20px",
        fontWeight: "700",
        color: "#1A237E",
        marginBottom: "16px",
        paddingLeft: "14px",
        borderLeft: "3px solid #EC4899",
        fontFamily: "sans-serif",
      }}>
        {title}
      </h2>
      {children}
    </div>
  );
}

function SubTitle({ children }) {
  return (
    <p style={{
      fontSize: "14px",
      fontWeight: "700",
      color: "#EC4899",
      textTransform: "uppercase",
      letterSpacing: "1px",
      marginTop: "10px",
      marginBottom: "10px",
      fontFamily: "sans-serif",
    }}>
      {children}
    </p>
  );
}

function P({ children }) {
  return (
    <p style={{
      fontSize: "15px",
      lineHeight: "1.85",
      color: "#444",
      marginBottom: "8px",
      fontFamily: "sans-serif",
    }}>
      {children}
    </p>
  );
}

function OL({ items }) {
  return (
    <ol style={{ paddingLeft: "20px", margin: 0 }}>
      {items.map((item, i) => (
        <li key={i} style={{
          fontSize: "15px",
          lineHeight: "1.85",
          color: "#444",
          marginBottom: "8px",
          fontFamily: "sans-serif",
        }}>
          {item}
        </li>
      ))}
    </ol>
  );
}